/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Body_3Inputs */

const en_wb_sales_body_3 = /** @type {(inputs: Wb_Sales_Body_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could connect the two, prepare the next reply and keep the lead record up to date, with your team reviewing anything that goes out.`)
};

const lv_wb_sales_body_3 = /** @type {(inputs: Wb_Sales_Body_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs varētu savienot abus, sagatavot nākamo atbildi un uzturēt klienta ierakstu aktuālu — ar Jūsu komandas pārbaudi visam, kas tiek nosūtīts.`)
};

/**
* | output |
* | --- |
* | "We could connect the two, prepare the next reply and keep the lead record up to date, with your team reviewing anything that goes out." |
*
* @param {Wb_Sales_Body_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_body_3 = /** @type {((inputs?: Wb_Sales_Body_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Body_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_body_3(inputs)
	return en_wb_sales_body_3(inputs)
});